/**
 * Copyright (c) 2020-2021 Perficient, Inc.
 * Unauthorized copying or distribution of this file prohibited without the express permission of Perficient.
 */

const imagePathPrefix = "/images/teams-statuses";

const presenceImagePaths = {
	Available: `${imagePathPrefix}/presence_available.png`,
	Away: `${imagePathPrefix}/presence_away.png`,
	BeRightBack: `${imagePathPrefix}/presence_away.png`,
	Busy: `${imagePathPrefix}/presence_busy.png`,
	DoNotDisturb: `${imagePathPrefix}/presence_dnd.png`,
	InACall: `${imagePathPrefix}/presence_busy.png`,
	InAConferenceCall: `${imagePathPrefix}/presence_busy.png`,
	Inactive: `${imagePathPrefix}/presence_offline.png`,
	InAMeeting: `${imagePathPrefix}/presence_busy.png`,
	Offline: `${imagePathPrefix}/presence_offline.png`,
	OffWork: `${imagePathPrefix}/presence_offline.png`,
	OutOfOffice: `${imagePathPrefix}/presence_oof.png`,
	PresenceUnknown: `${imagePathPrefix}/presence_unknown.png`,
	Presenting: `${imagePathPrefix}/presence_dnd.png`,
	UrgentInterruptionsOnly: `${imagePathPrefix}/presence_dnd.png`,
};

/**
 * Get teams presence icon by user status.
 * Returns 'unknown status' icon if status not found.
 * @param {string} status teams status
 * @returns {string} status image path
 */
export const getPresenceIcon = (status) => {
	const icon = presenceImagePaths[status];
	return icon || `${imagePathPrefix}/presence_unknown.png`;
};
